import { PieChart, Pie, Cell, Label, Tooltip } from 'recharts';

import { statusChartcolorsMap } from '../../utils/chart-colors';
import { CustomTooltip } from '../custom-tooltip/custom-tooltip';

interface DoubleDonutChartProps {
  centerLabel?: string;
  data01: {
    name: string;
    value: number;
    unit?: string;
  }[];
  data02: {
    name: string;
    value: number;
    unit?: string;
  }[];
  withTooltip?: boolean;
}

const DoubleDonutChart = ({
  data01 = [],
  data02 = [],
  withTooltip = true,
  centerLabel,
}: DoubleDonutChartProps) => {
  return (
    <PieChart height={200} style={{ flexGrow: 0 }} width={200}>
      <Pie
        cx="50%"
        cy="50%"
        data={data01}
        dataKey="value"
        innerRadius={40}
        isAnimationActive={false}
        outerRadius={60}
      >
        {data01.map((entry, index) => (
          <Cell
            fill={
              statusChartcolorsMap[
                entry.name as keyof typeof statusChartcolorsMap
              ]
            }
            key={`cell-${index}`}
          />
        ))}
        <Cell fill="black" />
        <Label fill="black" fontWeight={700} position="center" width={30}>
          {centerLabel}
        </Label>
      </Pie>
      <Pie
        cx="50%"
        cy="50%"
        data={data02}
        dataKey="value"
        innerRadius={70}
        isAnimationActive={false}
        outerRadius={100}
      >
        {data02.map((entry, index) => (
          <Cell
            fill={
              statusChartcolorsMap[
                entry.name as keyof typeof statusChartcolorsMap
              ]
            }
            key={`cell-${index}`}
          />
        ))}
      </Pie>
      {withTooltip ? <Tooltip content={CustomTooltip} /> : null}
    </PieChart>
  );
};

export default DoubleDonutChart;
